const CalendarLeftArrowIcon = () => {
  return <svg stroke='currentColor' fill='currentColor' strokeWidth='0' viewBox='0 0 24 24' id='next-prev-button' height='36' width='36' xmlns='http://www.w3.org/2000/svg' data-sentry-element="svg" data-sentry-component="CalendarLeftArrowIcon" data-sentry-source-file="CalendarLeftArrow.tsx">
      <path d='M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z' data-sentry-element="path" data-sentry-source-file="CalendarLeftArrow.tsx"></path>
    </svg>;
};
export default CalendarLeftArrowIcon;